<template>
    <div id="pinger-create">
        <div id="page-head">
            <ul id="breadcrumbs">
                <li><router-link :to="{ name: 'Dashboard' }">Dashboard</router-link></li>
                <li><router-link :to="{ name: 'PingerIndex' }">Site Pinger</router-link></li>
                <li>New Domain</li>
            </ul>
        </div>

        <div class="panel">
            <div class="panel-head">
                <h2>New Domain</h2>
            </div>
            <div class="panel-body">
                <form>
                    <div class="form-control">
                        <label for="client">Client</label>
                        <select v-model="pinger.client_id">
                            <option :value="null">--</option>
                            <option v-for="client in clients" :value="client.id">{{ client.name }}</option>
                        </select>
                    </div>
                    <div class="form-control-group">
                        <div class="form-control">
                            <label for="protocol">Protocol</label>
                            <select>
                                <option>https://</option>
                                <option>http://</option>
                            </select>
                        </div>

                        <div class="form-control grow-3x">
                            <label for="domain">Domain</label>
                            <input v-model="pinger.domain" type="text" placeholder="example.com">
                        </div>
                    </div>

                    <div class="form-control">
                        <label for="interval">Ping Interval</label>
                        <select v-model="pinger.interval">
                            <option value="1">Every Hour</option>
                            <option value="6">Every 6 Hours</option>
                            <option value="12">Every 12 Hours</option>
                            <option value="24">Every 24 Hours</option>
                            <option value="-1">Disabled</option>
                        </select>
                    </div>

                    <button @click.prevent="save()" class="button button-green">Save</button>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PingerCreate',
    data() {
        return {
            clients: [],
            pinger: {
                client_id: null,
                protocol: 'https://',
                domain: null,
                interval: 24
            }
        }
    },
    created() {
        this.loadClients()
    },
    methods: {
        async loadClients() {
            let response = await this.$http.get('/clients')
            this.clients = response.data
        },
        async save() {
            let response = await this.$http.post('/pingers', this.pinger)
            this.$router.replace({ name: 'PingerEdit', params: { id: response.data.id } })
        }
    }
}
</script>

<style lang="scss">
#pinger-create {

}
</style>
